export const __cloud__ = process.env.NEXT_PUBLIC_CLOUD === "true";
